import { Stack, Typography } from "@mui/material";

export const NoneSelectedRoom = () => {
  return (
    <Stack width="100%" height="100%" justifyContent="center" alignItems="center" gap={3}>
      <Typography variant="head24Semi">チャットを選択してください。</Typography>
    </Stack>
  );
};
